import { hidePageLoad, showPageLoad } from '../../../modules/actions'
import { customAxios as axios, getToken } from '../../../request'
import { addCourierUrl, addSubscriptionActivityUrl, updateInvoiceStatusUrl } from '../api'
import { notification } from 'antd'
import { allGeneralSubscriptionUrl,getSingleGeneralSubscriptionByIdUrl } from '../api'
import { getArticleByIdUrl } from '../../article/apis'

export const addSubscriptionActivityFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(addSubscriptionActivityUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}
export const updateInvoiceStatusFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(updateInvoiceStatusUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}
export const allGeneralSubscriptionFxn = (obj) => async (dispatch) => {
  // dispatch(showPageLoad())
  let config = {
    params: obj,
    ...getToken()
  }
  let { data } = await axios.get(allGeneralSubscriptionUrl(), config)
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}

export const getSingleGeneralSubscriptionByIdFxn = (subscriptionId, selected = {}) => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(
    getSingleGeneralSubscriptionByIdUrl(),
    { subscriptionId },
    getToken()
  )
  dispatch(hidePageLoad())

  return data
}
export const addCourierFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(addCourierUrl(), valData, getToken())
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}

